export default __webpack_public_path__ + "img/Poppins-Thin_79208bb.woff";